/* import __COLOCATED_TEMPLATE__ from './address-input-type-inverted-dropdowns-jp-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputTypeInvertedDropdownsJp from './address-input-type-inverted-dropdowns-jp';
let AddressInputTypeInvertedDropdownsJpOld = (_dec = tagName(''), _dec(_class = class AddressInputTypeInvertedDropdownsJpOld extends AddressInputTypeInvertedDropdownsJp {}) || _class);
export { AddressInputTypeInvertedDropdownsJpOld as default };